import { EditProspectCommand } from "../models/Prospect";
import api from "./api";

export const getProspects = async (filter: {
  status: boolean;
  client: string;
}) => {
  try {
    const response = await api.get(`/api/prospect`, { params: filter });
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};
export const uploadProspect = async (prospectId: string, file: File) => {
  try {
    let formData = new FormData();
    if (file) {
      formData.append("file", new File([file], file.name));
    }
    const response = await api.post(
      `/api/prospect/upload/${prospectId}`,
      formData
    );
    if (!response.data.success) {
      console.log("error", response.data.notifications);
    }
    return response;
  } catch (err) {}
};
export const getProspectIdByCvfRef = async (cvfRef: string) => {
  try {
    const response = await api.get(
      `/api/prospect/ProspectIdByCvfRef?cvfRef=${cvfRef}`
    );
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getProspectById = async (id: string) => {
  try {
    const response = await api.get(`/api/prospect/${id}`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateProspect = async (prospect: EditProspectCommand) => {
  try {
    const response = await api.put(`/api/prospect/${prospect.id}`, prospect);
    if (!response.data.success) {
      console.log("asd-error", response.data);
    }
    return response;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const getLastProspect = async () => {
  try {
    const response = await api.get(`/api/prospect/last`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const saveProspect = async (prospect: EditProspectCommand) => {
  try {
    const response = await api.post(`/api/prospect`, prospect);
    if (!response.data.success) {
      console.log("asd-error", response.data);
    }
    return response;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const downloadFile = async () => {
  try {
    const response = await api.post(`/api/prospect/followUp`);
    if (!response.data) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("asd-error", error);
  }
};
